

module.exports.FB_URL = 'https://www.facebook.com/AlgerieDocto'
module.exports.TWITTER_URL = 'https://twitter.com/AlgerieDocto'




